import { type ReactNode, useEffect } from "react";
import { createPortal } from "react-dom";
import { MdClose } from "react-icons/md";

export function Modal({
                        open,
                        onClose,
                        title,
                        children,
                        footer,
                      }: {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  useEffect(() => {
    if (!open) {
      return;
    }

    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div
        className="bg-white rounded-lg shadow-2xl w-full max-w-5xl max-h-[90vh] flex flex-col overflow-hidden"
        onClick={e => e.stopPropagation()}
      >
        <header className="flex items-center justify-between px-4 py-3 border-b border-[#ddd]">
          <h2 className="text-lg font-semibold m-0">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="p-1 rounded hover:bg-[#f5f5f5] text-[#666]"
          >
            <MdClose size={20}/>
          </button>
        </header>
        <div className="flex-1 overflow-auto">{children}</div>
        {footer ? <footer className="flex justify-end gap-2 px-4 py-3 border-t border-[#ddd]">{footer}</footer> : null}
      </div>
    </div>,
    document.body,
  );
}
